import React from "react";

export default function LockIcon({ className = "w-16 h-16" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="16"
                y="28"
                width="32"
                height="28"
                rx="4"
                fill="#7FFF00"
                stroke="#0A1E3E"
                strokeWidth="2"
            />
            <path
                d="M22 28V20C22 14.4772 26.4772 10 32 10C37.5228 10 42 14.4772 42 20V28"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <circle cx="32" cy="42" r="4" fill="#0A1E3E" />
            <path
                d="M32 46V50"
                stroke="#0A1E3E"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}
